import { AuthenticationLayouts } from "#src/batteries-included-components/Layouts/Authentication";
import { useAuthenticatedContext } from "#src/contexts/AuthenticatedContext.helpers";
import { ExceptionUtils } from "#src/utils/exception";
import { Button } from "@validereinc/common-components";
import React, { useEffect } from "react";
import { RouteComponentProps } from "react-router";
import LayoutContent from "./LayoutContent";

export const Layout = (props: RouteComponentProps) => {
  const { isLoading, isErrored, isSwitching, logout } =
    useAuthenticatedContext();

  useEffect(() => {
    if (isLoading || isErrored) return;

    ExceptionUtils.registerLifecycleEvent({
      category: "tenant",
      type: "info",
      message: "Loaded session & tenant details. App is ready.",
    });
  }, [isLoading]);

  if (isErrored) {
    return (
      <AuthenticationLayouts.ErrorOnLoginCallbackLayout
        action={
          <Button
            variant="primary"
            onClick={() => logout()}
            icon="arrow-left"
            iconProps={{
              size: 16,
            }}
          >
            Return to Login
          </Button>
        }
      />
    );
  }

  if (isSwitching) {
    return <AuthenticationLayouts.SwitchingCompanyLayout />;
  }

  if (isLoading) {
    return <AuthenticationLayouts.LoadingOnLoginLayout />;
  }

  return <LayoutContent {...props} />;
};

export default Layout;
